import { Component, OnInit  } from '@angular/core';
import { GlobalVariableService } from '../../Shared/global-variable.service';
import { Router } from '@angular/router';
import { ChartData, ChartType } from 'chart.js';
import { MaterialModule } from 'src/app/Shared/Material/material.module';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})

export class DashboardComponent implements OnInit {

  displayedColumns: string[] = ['Fund Name', 'Gross Commitment', 'Net Commitment'];
  whiteoakColumns: string[] = ['Fund Name','FolioNo', 'Class', 'Gross Commitment', 'Net Commitment', 'NAV', 'CB','CV', 'NAV Date'];
  oldBridgeColumn: string[] = ['Fund Name','Share Class','Portfolio Value','XIRR','CA', 'Con Amount', 'Units'];
  arthaColumn: string[] = ['Fund Name','Share Class','CA', 'Con Amount', 'Units'];
  displayedRows: string[];
  dataSource;
  imagePath = "";
  urlname: string;

  public bgcolor;
  public chartShow = false;

  Dashboardpage: boolean = false;
  Dashboardpage1: boolean = false;
  whiteoakChange: boolean = false;
  whiteoakChange1: boolean = false;
  public tooltip: Object;
  public labelArray: any = [];
  public chdata: any[] = [];
  oldBridgeTable: boolean = false;
  arthaTable: boolean = false;
  pathSrc: string;
  palette: string[];
  whiteoakData;
  finalDataWhiteoak: any;

  constructor(public _globalVariableService: GlobalVariableService,
    private router: Router) {
    this.imagePath = router.routerState.snapshot.url;
    let split = this.imagePath.split("/");
    let a = split[1];
    this.pathSrc = a;
    //console.log(a);
    this.urlname = a;
    if (a == "nisus") {
      this.Dashboardpage = false;
      this.Dashboardpage1 = true;
      this.whiteoakChange = false;
      this.whiteoakChange1 = true;
    }
    else if (a == "dnisus") {
      this.Dashboardpage = false;
      this.Dashboardpage1 = true;
      this.whiteoakChange1 = false;
      this.whiteoakChange = false;
    }
    else if (a == "whiteoak") {
      this.Dashboardpage = true;
      this.Dashboardpage1 = false
      this.whiteoakChange1 = false;
      this.whiteoakChange = true;
    }
    // JK 11/10/2021
    else if (a == 'oldBridge') {
      this.Dashboardpage = true;
      this.Dashboardpage1 = false;
      this.whiteoakChange1 = false;
      this.whiteoakChange = false;
      this.oldBridgeTable = true;

    }
    else if (a == 'Artha') {
      this.Dashboardpage = true;
      this.Dashboardpage1 = false;
      this.whiteoakChange1 = false;
      this.whiteoakChange = false;
      this.arthaTable = true;
    } 
    else {
      this.Dashboardpage = true;
      this.Dashboardpage1 = false
      this.whiteoakChange1 = true;
      this.whiteoakChange = false;
    }
  }

 public doughnutChartData: ChartData<'doughnut'> = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: []
      }
    ]
  };
  public doughnutChartType: ChartType = 'doughnut';
  public chatTooltip: any = [];
  public charttitle: string;
  public legend: boolean = true;
  public colorcodes: any = [
    '#0DBDBD',
    '#000000',
    '#1265E2',
    '#fa8072',
    '#ffa500',
    '#c8cae6',
    '#70cae6',
    '#708de6',
    '#000b8f',
    '#6e0b8f',
    '#ba0b8f',
    '#ff0b8f',
    '#ffa38f',
    '#ffc6bb',
   ];
   public colorcodess: any = [
    '#6ACFF6',
    '#424142',
    '#939598',
    '#0DBDBD',
    '#000000',
    '#1265E2',
    '#fa8072',
    '#ffa500',
    '#c8cae6',
    '#70cae6',
    '#708de6',
    '#000b8f',
    '#6e0b8f',
    '#ba0b8f',
    '#ff0b8f',
    '#ffa38f',
    '#ffc6bb',
   ];




  finalArray = [];
  public ChartColors: Array<any> = [{
    backgroundColor: [],
    borderColor: []
  }];
  public options: any = {
    tooltips: {
      callbacks: {
        label: function (context) {
          const label = context.label || '';
          return label;
        }
      }
    },
    // responsive: true,    
    cutoutPercentage: 50,
    // pointStyle: 'rectRounded',
    //   legendItemClick: function(e){
    //     //console.log("Clicked an item with text: " + e.text);
    //     e.preventDefault();
    // },
    legend: {
      onClick: function (e) {
        e.stopPropagation();
      },
      position: 'left',
      align: 'start',
      display: false,
      //   horizontalAlign: "left",    
      labels: {
        margin: 10,
        // onClick: function (e) {
        //   e.stopPropagation();
        // },
        onClick: null,
        //  fontColor: 'rgb(255, 99, 132)',
        usePointStyle: true,
        //  pointStyle: 'cross'
      }
    }
  }



  ngOnInit() {


    this.bgcolor = this._globalVariableService.bgColor;
    this._globalVariableService.pageTitle = "dashboard";
    this._globalVariableService.itableSubject.subscribe((data) => {
      if (data != '' && data != null) {
        this.getTableArray(data);
      }
    });

    this._globalVariableService.chartBhsubject.subscribe((data) => {
      if (data != '' && data != null) {
        this.loadChart(data);
      }
    });
  }

  loadChart(data, index: any = [] ) {
   //console.logdata,"chart")


    if (data[0].SUB_FUND_NAME == "All Funds") {
      data.shift();
    }


    // //console.log(data, 'load chrt')

    if (this.pathSrc != 'oldBridge'&&this.pathSrc != 'Artha') {
    this.doughnutChartData.labels = [];
    this.doughnutChartData.datasets[0].data = [];
    let chararr = [];
    let k = data.length > 5 ? 5 : data.length;

    if (data.length > 0) {
      this.labelArray = [];
      for (let i = 0; i < k; i++) {
        let daily_div_acc_amt = this.convertAmountFormatChart(data[i].DAILY_DIV_ACCRUED_AMT);
        let index = data[i].selected_index || i
        chararr.push({
          SUB_FUND_NAME: data[i].SUB_FUND_NAME,
          DAILY_DIV_ACCRUED_AMT: daily_div_acc_amt,
          SUB_FUND_PERC: data[i].SUB_FUND_PERC ? data[i].SUB_FUND_PERC : 50,
          selected_index: index,
        });
        if (this.pathSrc == 'oldBridge'||this.pathSrc == 'Artha') {
          this.ChartColors[0].backgroundColor.push(this.colorcodess[index] ? this.colorcodess[index] : '#f0c28f');
          this.ChartColors[0].borderColor.push('white');
          var bulletColor = this.colorcodess[index] ? this.colorcodess[index] : '#f0c28f';
          //console.logbulletColor,"old")
          let palettecolor = [ '#6ACFF6','#424142','#939598','#0DBDBD', '#000000','#1265E2','#fa8072','#ffa500',
          '#c8cae6','#70cae6','#708de6','#000b8f','#6e0b8f','#ba0b8f','#ff0b8f','#ffa38f','#ffc6bb'];
          if(data && data.length  == 1) {
            this.palette = [palettecolor[index]];
          } else {
            this.palette = palettecolor
          }
        } else {
          this.ChartColors[0].backgroundColor.push(this.colorcodes[i] ? this.colorcodes[i] : '#f0c28f');
          this.ChartColors[0].borderColor.push('white');
          var bulletColor = this.colorcodes[i] ? this.colorcodes[i] : '#f0c28f';
        }
        let labnameamt = data[i].DAILY_DIV_ACCRUED_AMT.split('.');
        let labnameamt2 = labnameamt[1].split(' ');
        let labname1 = data[i].SUB_FUND_NAME;
        let labname2 = labnameamt[0];
        let labname3 = labnameamt2[0];
        let labname4 = labnameamt2[1];
        let labname5 = data[i].SUB_FUND_PERC.toFixed(2);
        this.labelArray.push({
          "bulletcolor": bulletColor,
          "labname1": labname1,
          "labname2": labname2,
          "labname3": labname3,
          "labname4": labname4,
          "labname5": labname5
        });
        // //console.log(this.labelArray)
      }
      for (let chart of chararr) {
        // let legent = chararr;
        // //console.log(legent,"test")
        let tooltip = chart.SUB_FUND_NAME + "(" + chart.SUB_FUND_PERC.toFixed(2) + "%" + ")";
        this.chatTooltip.push(tooltip)
        let label = chart.SUB_FUND_NAME + " - " + chart.DAILY_DIV_ACCRUED_AMT + " (" + chart.SUB_FUND_PERC.toFixed(2) + "%" + ")";
        let perc = chart.SUB_FUND_PERC;
        this.doughnutChartData.labels?.push(label);
        this.doughnutChartData.datasets[0].data.push(parseFloat(perc.toFixed(2)));
      }
      // //console.log(chararr, 'chart arr')
      // this.chdata = [{ x: 'Labour', y: 18, text: '18%' },
      // { x: 'Taxes', y: 14, text: '14%' },
      // { x: 'Insurance', y: 16, text: '16%' }];
      this.chdata = chararr;
      this.charttitle ='Your Total Portfolio'
      this.tooltip = {
        enable: true, header: "Pie Chart"
      }
      this.tooltip = {
        enable: true, header: "Pie Chart"
      }
      this.chartShow = true;
     } else {
      this.chartShow = false;
   }
  }
  }

  convertAmountFormatChart(value) {
    let amt1;
    let amt2;
    let amt3;
    if (value) {
      let splitval = value.split('.');
      amt1 = splitval[0];
      let splitval1 = splitval[1].split(' ');
      amt2 = splitval1[0];
      amt3 = splitval1[1];
      return amt1 + ".oo" + " " + amt3
    } else {
      return null;
    }

  }


  convertAmountFormat(value) {
    let amt1;
    let amt2;
    let amt3;
    if (value) {
      let splitval = value.split('.');
      amt1 = splitval[0];
      let splitval1 = splitval[1].split(' ');
      amt2 = splitval1[0];
      amt3 = splitval1[1];
      return {
        Amt1: amt1,
        Amt2: amt2,
        Amt3: amt3
      };
    } else {
      return null;
    }

  }
  total: number;
  createPercentageValue() {
    this.total = 0;
    for (let row of this.labelArray) {
      this.total += parseFloat(row['labname5']);
    }
    for (let row of this.labelArray) {
      let percent = ((parseFloat(row['labname5']) / this.total) * 100).toFixed(2)
      row['percentage'] = percent != "NaN" ? percent : 0.00;
    }
  }

  totalChart: number;
  getTableArray(data) {
    if (this.pathSrc == 'oldBridge'||this.pathSrc == 'Artha') {
      this.doughnutChartData.labels = [];
      this.totalChart = 0;
      this.doughnutChartData.datasets[0].data = [];
      let chararr = [];
      let k = data.detail.length > 5 ? 5 : data.detail.length;
      if (data.detail.length > 0) {
        this.labelArray = [];
        for (let i = 0; i < k; i++) {
          let daily_div_acc_amt:any = data.detail[i].NAV_VALUE * data.detail[i].AVAILABLE_UNITS;
          this.totalChart += parseFloat(daily_div_acc_amt);
          let index = data.detail[i].selected_index || i
          chararr.push({
            SUB_FUND_NAME: data.detail[i].SUB_FUND_NAME,
            DAILY_DIV_ACCRUED_AMT: daily_div_acc_amt,
            SUB_FUND_PERC: ((parseFloat(daily_div_acc_amt) / this.totalChart) * 100).toFixed(2),
            selected_index: index,
          });
          if (this.pathSrc == 'oldBridge'||this.pathSrc == 'Artha') {
            this.ChartColors[0].backgroundColor.push(this.colorcodess[index] ? this.colorcodess[index] : '#f0c28f');
            this.ChartColors[0].borderColor.push('white');
            var bulletColor = this.colorcodess[index] ? this.colorcodess[index] : '#f0c28f';
            //console.logbulletColor,"old")
            let palettecolor = ['#6ACFF6', '#424142', '#939598', '#0DBDBD', '#000000', '#1265E2', '#fa8072', '#ffa500',
              '#c8cae6', '#70cae6', '#708de6', '#000b8f', '#6e0b8f', '#ba0b8f', '#ff0b8f', '#ffa38f', '#ffc6bb'];
            if (data && data.length == 1) {
              this.palette = [palettecolor[index]];
            } else {
              this.palette = palettecolor
            }


          } else {
            this.ChartColors[0].backgroundColor.push(this.colorcodes[i] ? this.colorcodes[i] : '#f0c28f');
            this.ChartColors[0].borderColor.push('white');
            var bulletColor = this.colorcodes[i] ? this.colorcodes[i] : '#f0c28f';
          }
          let labnameamt = daily_div_acc_amt;
          // let labnameamt2 = labnameamt[1].split(' ');
          let labname1 = data.detail[i].SUB_FUND_NAME;
          let labname2 = (daily_div_acc_amt / 10000000).toFixed(2) + ' ' + 'Cr';
          // let labname3 = labnameamt2[0];
          // let labname4 = labnameamt2[1];
          let labname5 = (Math.round(daily_div_acc_amt * 100) / 100).toFixed(2)

          this.labelArray.push({
            "bulletcolor": bulletColor,
            "labname1": labname1,
            "labname2": labname2,
            // "labname3": labname3,
            // "labname4": labname4,
            "labname5": labname5
          });

        }

        this.createPercentageValue();

        for (let chart of chararr) {
          chart['SUB_FUND_PERC'] = ((parseFloat(chart['DAILY_DIV_ACCRUED_AMT']) / this.totalChart) * 100).toFixed(2);
          let tooltip = chart.SUB_FUND_NAME + "(" + (chart.NAV_VALUE * chart.AVAILABLE_UNITS / 10000000).toFixed(2) + "%" + ")";
          this.chatTooltip.push(tooltip)
          let label = chart.SUB_FUND_NAME + " - " + chart.DAILY_DIV_ACCRUED_AMT + " (" + chart.SUB_FUND_PERC + "%" + ")";
          let perc = chart.NAV_VALUE * chart.AVAILABLE_UNITS
          this.doughnutChartData.labels?.push(label);
          this.doughnutChartData.datasets[0].data.push(perc);
        }
        // //console.logchararr, 'chart arr')
        // this.chdata = [{ x: 'Labour', y: 18, text: '18%' },
        // { x: 'Taxes', y: 14, text: '14%' },
        // { x: 'Insurance', y: 16, text: '16%' }];
        this.chdata = chararr;
        this.charttitle = 'Your Total Portfolio'
        this.tooltip = {
          enable: true, header: "Pie Chart"
        }
        this.tooltip = {
          enable: true, header: "Pie Chart"
        }
        this.chartShow = true;
      } else {
        this.chartShow = false;
     }
    }
    this.dataSource = [];
    let fundname = "";
    this.finalArray = [];
    let split = this.imagePath.split("/");
    let a = split[1];
    this.urlname = a;
    this.whiteoakData = data.detail
    if (!(data.selectedoptions.subfuncode && data.selectedoptions.foliono)) {
      for (let i = 0; i < data.detail.length; i++) {
          fundname = data.detail[i].SUB_FUND_CODE;


          let gross_amt_fund = this.convertAmountFormat(data.detail[i].SUB_FUND_AMT);
          let net_amt_fund = this.convertAmountFormat(data.detail[i].POSTED_SUB_FUND_AMT);

          if (a == "dnisus") {
            this.finalArray.push({
              "name": data.detail[i].SUB_FUND_NAME,
  
              "gross_amt1": gross_amt_fund.Amt1,
              "gross_amt2": gross_amt_fund.Amt2,
              "gross_amt3": gross_amt_fund.Amt3,
  
  
              "net_amt1": net_amt_fund.Amt1,
              "net_amt2": net_amt_fund.Amt2,
              "net_amt3": net_amt_fund.Amt3,

              "nav_date": data.detail[i].NAV_DATE,
              "SubFund_Code": data.detail[i].SUB_FUND_CODE,
               "isHeader": true
            });
          }
          else if (a == "whiteoak") {
            this.finalArray.push({
              "name": data.detail[i].SUB_FUND_NAME ,
              "gross_amt1": gross_amt_fund.Amt1,
              "gross_amt2": gross_amt_fund.Amt2,
              "gross_amt3": gross_amt_fund.Amt3,
              "net_amt1": net_amt_fund.Amt1,
              "net_amt2": net_amt_fund.Amt2,
              "net_amt3": net_amt_fund.Amt3,
              "nav_amt": ((data.detail[i].NAV_VALUE == '') ? "-" : data.detail[i].NAV_VALUE),
              "nav_date": data.detail[i].NAV_DATE,
              "current_unit": data.detail[i].AVAILABLE_UNITS,
              "SubFund_Code": data.detail[i].SUB_FUND_CODE,
              'folioNo' : data.detail[i].FOLIO_NO,
              'class' : data.detail[i].CLASS_VALUE,
              "investername" : data.detail[i].INV_NAME,
              "xxirnumber" : data.detail[i].ANNULAISED_XIRR_FOLIO,
               "isHeader": true
            });
          } 
        else if (a == "oldBridge"||a == "Artha") {
            //console.log(data.detail[i],"test2")
            this.finalArray.push({
              "name": data.detail[i].SUB_FUND_NAME ,
              "gross_amt1": gross_amt_fund.Amt1,
              "gross_amt2": gross_amt_fund.Amt2,
              "gross_amt3": gross_amt_fund.Amt3,
              "net_amt1": net_amt_fund.Amt1,
              "net_amt2": net_amt_fund.Amt2,
              "net_amt3": net_amt_fund.Amt3,
              "nav_amt": ((data.detail[i].NAV_VALUE == '') ? "-" : data.detail[i].NAV_VALUE),
              "nav_date": data.detail[i].NAV_DATE,
              "current_unit": data.detail[i].AVAILABLE_UNITS,
              "SubFund_Code": data.detail[i].SUB_FUND_CODE,
              'folioNo' : data.detail[i].FOLIO_NO,
              'class' : data.detail[i].CLASS_VALUE,
              "investername" : data.detail[i].INV_NAME,
              "xxirnumber" : data.detail[i].ANNULAISED_XIRR_FOLIO,
               "isHeader": true,
               "portfolio_value": (data.detail[i].NAV_VALUE * data.detail[i].AVAILABLE_UNITS)
            });
            this._globalVariableService.usernameHeader = this.finalArray[0].investername || "";

          }
          else {
            this.finalArray.push({
              "name": data.detail[i].SUB_FUND_NAME + ' - ' + data.detail[i].SUB_FUND_CODE,
              "gross_amt1": gross_amt_fund.Amt1,
              "gross_amt2": gross_amt_fund.Amt2,
              "gross_amt3": gross_amt_fund.Amt3,
              "net_amt1": net_amt_fund.Amt1,
              "net_amt2": net_amt_fund.Amt2,
              "net_amt3": net_amt_fund.Amt3,
              'folioNo' : data.detail[i].FOLIO_NO,
              'class' : data.detail[i].CLASS_VALUE,
              "nav_date": data.detail[i].NAV_DATE,
              "SubFund_Code": data.detail[i].SUB_FUND_CODE, "isHeader": true
            });
          }
        //   else{  
        //     this.finalArray.push({
        //     "name": data.detail[i].SUB_FUND_NAME + ' - ' + data.detail[i].SUB_FUND_CODE,

        //     "gross_amt1": gross_amt_fund.Amt1,
        //     "gross_amt2": gross_amt_fund.Amt2,
        //     "gross_amt3": gross_amt_fund.Amt3,


        //     "net_amt1": net_amt_fund.Amt1,
        //     "net_amt2": net_amt_fund.Amt2,
        //     "net_amt3": net_amt_fund.Amt3,

        //     "SubFund_Code": data.detail[i].SUB_FUND_CODE, "isHeader": true
        //   });
        // }
        // if (a == "whiteoak") {
        //   this.finalArray.push({
        //     "name": 'Folio No', "isHeader": true, "value": 'class'
        //   })

        // }
        let gross_amt_fol = this.convertAmountFormat(data.detail[i].DAILY_DIV_ACCRUED_AMT);
        let net_amt_fol = this.convertAmountFormat(data.detail[i].DAILY_DIV_POSTED_AMT);

        if (a == "whiteoak") {

          // this.finalArray.push({
          //   // "name": data.detail[i].FOLIO_NO + '(' + data.detail[i].CLASS_VALUE + ')',
          //   "name": data.detail[i].FOLIO_NO,
          //   "class": data.detail[i].CLASS_VALUE,
          //   "gross_amt1": gross_amt_fol.Amt1,
          //   "gross_amt2": gross_amt_fol.Amt2,
          //   "gross_amt3": gross_amt_fol.Amt3,
          //   "net_amt1": net_amt_fol.Amt1,
          //   "net_amt2": net_amt_fol.Amt2,
          //   "net_amt3": net_amt_fol.Amt3,
          //   "nav_amt": data.detail[i].NAV_VALUE,
          //   "nav_date": data.detail[i].NAV_DATE,
          //   "subfund_code": data.detail[i].SUB_FUND_CODE, "isHeader": false
          // });
 
        }else if(a == "oldBridge"||a == "Artha"){

        }
        else {
          this.finalArray.push({
            "name": data.detail[i].FOLIO_NO + '(' + data.detail[i].SCHEME_CODE_1 + ')',

          "gross_amt1": gross_amt_fol.Amt1,
          "gross_amt2": gross_amt_fol.Amt2,
          "gross_amt3": gross_amt_fol.Amt3,


          "net_amt1": net_amt_fol.Amt1,
          "net_amt2": net_amt_fol.Amt2,
          "net_amt3": net_amt_fol.Amt3,



            "subfund_code": data.detail[i].SUB_FUND_CODE, "isHeader": false
          });
        }
    }
  }
    if (data.selectedoptions.subfuncode && data.selectedoptions.foliono) {
      let k = data.detail.length > 1 ? 1 : 0;
      for (let i = 0; i < data.detail.length - k; i++) {
          fundname = data.detail[i].SUB_FUND_CODE;
          let gross_amt_oth_fund = this.convertAmountFormat(data.detail[i].GROSS_AMT);
          let net_amt_oth_fund = this.convertAmountFormat(data.detail[i].NET_AMOUNT);


          let split = this.imagePath.split("/");
          let a = split[1];
          this.urlname = a;
          if (a == "dnisus") {
            this.finalArray.push({
              "name": data.detail[i].SUB_FUND_NAME,
  
              "gross_amt1": gross_amt_oth_fund.Amt1,
              "gross_amt2": gross_amt_oth_fund.Amt2,
              "gross_amt3": gross_amt_oth_fund.Amt3,
  
  
              "net_amt1": net_amt_oth_fund.Amt1,
              "net_amt2": net_amt_oth_fund.Amt2,
              "net_amt3": net_amt_oth_fund.Amt3,
  
  
              "SubFund_Code": data.detail[i].SUB_FUND_CODE, "isHeader": true
            });
          }
          else if (a == "whiteoak") {
            this.finalArray.push({
              "name": data.detail[i].SUB_FUND_NAME ,
              "gross_amt1": gross_amt_oth_fund.Amt1,
              "gross_amt2": gross_amt_oth_fund.Amt2,
              "gross_amt3": gross_amt_oth_fund.Amt3,
              "net_amt1": net_amt_oth_fund.Amt1,
              "net_amt2": net_amt_oth_fund.Amt2,
              "net_amt3": net_amt_oth_fund.Amt3,
              "nav_amt": ((data.detail[i].NAV_VALUE == '') ? "-" : data.detail[i].NAV_VALUE),
              "nav_date": data.detail[i].NAV_DATE,
              "current_unit": data.detail[i].AVAILABLE_UNITS,
              "SubFund_Code": data.detail[i].SUB_FUND_CODE,
              'folioNo' : data.detail[i].FOLIO_NO,
              'class' : data.detail[i].CLASS_VALUE, 
              "isHeader": true
            });
          } else if (a == "oldBridge"||a == "Artha") {
            this.finalArray.push({
              "name": data.detail[i].SUB_FUND_NAME,
              "gross_amt1": gross_amt_oth_fund.Amt1,
              "gross_amt2": gross_amt_oth_fund.Amt2,
              "gross_amt3": gross_amt_oth_fund.Amt3,
              "net_amt1": net_amt_oth_fund.Amt1,
              "net_amt2": net_amt_oth_fund.Amt2,
              "net_amt3": net_amt_oth_fund.Amt3,
              "nav_amt": ((data.detail[i].NAV_VALUE == '') ? "-" : data.detail[i].NAV_VALUE),
              "nav_date": data.detail[i].NAV_DATE,
              "current_unit": data.detail[i].AVAILABLE_UNITS,
              "SubFund_Code": data.detail[i].SUB_FUND_CODE,
              'folioNo' : data.detail[i].FOLIO_NO,
          "investername" : data.detail[i].INV_NAME,
          'class' : data.detail[i].CLASS_VALUE, 
          "xxirnumber" : data.detail[i].ANNULAISED_XIRR_FOLIO,
              "isHeader": true,
              "portfolio_value": (data.detail[i].NAV_VALUE * data.detail[i].AVAILABLE_UNITS)
            });
          }
          else {
            this.finalArray.push({
              "name": data.detail[i].SUB_FUND_NAME + ' - ' + data.detail[i].SUB_FUND_CODE,

              "gross_amt1": gross_amt_oth_fund.Amt1,
              "gross_amt2": gross_amt_oth_fund.Amt2,
              "gross_amt3": gross_amt_oth_fund.Amt3,


              "net_amt1": net_amt_oth_fund.Amt1,
              "net_amt2": net_amt_oth_fund.Amt2,
              "net_amt3": net_amt_oth_fund.Amt3,

              "SubFund_Code": data.detail[i].SUB_FUND_CODE, "isHeader": true
            });
          }

        let gross_amt_oth_fol = this.convertAmountFormat(data.detail[i].DAILY_DIV_ACCRUED_AMT);
        let net_amt_oth_fol = this.convertAmountFormat(data.detail[i].NET_AMOUNT);

        if (a != "whiteoak" && a != "oldBridge"&& a != "Artha") {
          this.finalArray.push({
            "name": data.detail[i].FOLIO_NO + '( ' + data.detail[i].SCHEME_CODE + ')',
            "gross_amt1": gross_amt_oth_fol.Amt1,
            "gross_amt2": gross_amt_oth_fol.Amt2,
            "gross_amt3": gross_amt_oth_fol.Amt3,
            "net_amt1": net_amt_oth_fol.Amt1,
            "net_amt2": net_amt_oth_fol.Amt2,
            "net_amt3": net_amt_oth_fol.Amt3,
            "subfund_code": data.detail[i].SUB_FUND_CODE,
            "isHeader": false
          });
          this.dataSource = data.detail[i];
        }
       
      }
      if (a != "whiteoak" && a != "oldBridge"&& a != "Artha") {
        if (data.detail.length > 1) {

          if (data.detail[data.detail.length - 1].SCHEME_CODE == null) {


            let gross_amt_oth_fund_det = this.convertAmountFormat(data.detail[data.detail.length - 1].DAILY_DIV_ACCRUED_AMT);
            let net_amt_oth_fund_det = this.convertAmountFormat(data.detail[data.detail.length - 1].NET_AMOUNT);

            this.finalArray.push({
              "name": data.detail[data.detail.length - 1].FOLIO_NO,

              "gross_amt1": gross_amt_oth_fund_det.Amt1,
              "gross_amt2": gross_amt_oth_fund_det.Amt2,
              "gross_amt3": gross_amt_oth_fund_det.Amt3,


              "net_amt1": net_amt_oth_fund_det.Amt1,
              "net_amt2": net_amt_oth_fund_det.Amt2,
              "net_amt3": net_amt_oth_fund_det.Amt3,

              "subfund_code": data.detail[data.detail.length - 1].SUB_FUND_CODE,
              "isHeader": false
            });
          } else {

            let gross_amt_oth_fol_det = this.convertAmountFormat(data.detail[data.detail.length - 1].DAILY_DIV_ACCRUED_AMT);
            let net_amt_oth_fol_det = this.convertAmountFormat(data.detail[data.detail.length - 1].NET_AMOUNT);


            this.finalArray.push({
              "name": data.detail[data.detail.length - 1].FOLIO_NO + '( ' + data.detail[data.detail.length - 1].SCHEME_CODE + ')',

              "gross_amt1": gross_amt_oth_fol_det.Amt1,
              "gross_amt2": gross_amt_oth_fol_det.Amt2,
              "gross_amt3": gross_amt_oth_fol_det.Amt3,


              "net_amt1": net_amt_oth_fol_det.Amt1,
              "net_amt2": net_amt_oth_fol_det.Amt2,
              "net_amt3": net_amt_oth_fol_det.Amt3,


              "subfund_code": data.detail[data.detail.length - 1].SUB_FUND_CODE, "isHeader": false
            });
          }

        }
      }
}
      
    this.finalArray.splice(4, 6);
    if (a == "oldBridge"||a == "Artha") {
      this.finalArray.sort((a, b) => b.portfolio_value - a.portfolio_value);
    }
    
    this.dataSource = this.finalArray;
 
}
  
decimalPoint(num) {
  return (num/10000000).toFixed(2);
}
decimalUnit(num) {
  return num ? num.toFixed(4) : num;
  // return (Math.round(num * 100) / 100).toFixed(2);
}
decimalXirr(num) {
  return num ? num.toFixed(2) : num;
  // return (Math.round(num * 100) / 100).toFixed(2);
}
}
